// Call plugin.
import * as actionTypes from '../actionTypes'

// Libraries.
import { handleActions } from 'redux-actions'

/**
 * The devices substate keeps tracks the of the media devices available for use.
 */
const reducers = {}

// Replace old devices with newly checked devices.
reducers[actionTypes.DEVICES_CHANGE] = {
  next (state, action) {
    return action.payload
  }
}

// Replace with newly checked devices.
reducers[actionTypes.INITIALIZE_DEVICES_FINISH] = {
  next (state, action) {
    return action.payload
  }
}

// The initial state of the reducer.
const defaultState = {
  camera: [],
  microphone: [],
  speaker: []
}

const reducer = handleActions(reducers, defaultState)
export default reducer
